import { coerceBooleanProperty } from '@angular/cdk/coercion'
import { Directive, ElementRef, Input, OnInit } from '@angular/core'

// todo create a component instead of directive
@Directive({
  selector: '[mmxButtonGroup]',
  standalone: false,
})
export class ButtonGroupDirective implements OnInit {
  @Input() color: string
  @Input() moreMenu: boolean

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.el.nativeElement.classList.add('button-group')

    if (coerceBooleanProperty(this.moreMenu)) {
      this.el.nativeElement.classList.add('button-group-has-more-menu')
    }
  }
}
